import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'', WorkingHours:[]};				
	}

	componentDidMount() {		
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
		axios.post(process.env.REACT_APP_API_ENV+'api/hours.php')
			.then(result => {				
				this.setState({WorkingHours:result.data})													
			})			
	}
	render() {		
		return(
			<div id="content">
				<CommonHeader titles="Payday Loan Failed"/>
				<h2>{this.state.CompName}--Payday Loan Provider for Canadians</h2><br/>
				<h3><span>Welcome to {this.state.CompName}</span></h3><br />
				<p>Our office hours: Monday to Friday (except weekends and holidays) from {this.state.WorkingHours[0] + ' to ' + this.state.WorkingHours[1]}</p><br/>
				<p>Sorry, by policy you are not qualified for our payday loan due to your income, we are not able to process your application. Sorry for this inconvenience.</p><br/>
				<p>You are welcome back if your status has changed in the future.</p><br/>
				<p>Thank you for your trust with {this.state.CompName}</p><br/>
				<h3><b>{this.state.CompName + ' Team'}</b></h3><br/><br/>				
			</div>
		)
	}
}

export default HomtContents